import { toPriceCurrency } from '@/utils/filters'

export default ({ isPreview }) => ({
  isAutoLoad: false,
  store: {
    get: {
      url: 'Stocks/GetAllDynamic',
      selected: [
        'id', 'id as stockID', 'status.title as statusTitle',
        'ppwPath', 'stockLocation.title as locationTitle', 'partID', 'entryDate', 'supplierCompanyID',
        'supplierCompany.name as supplierCompanyName', 'partSN', 'sellPrice', 'partPrice', 'priceCurrencyID',
        'sellExchCurrency.title as currencyTitle',
        'conditionID', 'condition.title as conditionTitle', 'releaseID', 'release.title as releaseTitle',
        'traceabilityCompanyID', 'traceabilityCompany.name as traceabilityCompanyName', 'tagInfoCompanyID',
        'tagInfoCompany.name as tagInfoCompanyName', 'tagDate', 'sellExchCurrencyID', 'exchPrice', 'qty',
        'externalLocationCompany.name as externalLocationCompanyName',
        'part.partNumber as partNumber', 'tagInfoCompany.name as tagBy', 'stockLocation.title as stockLocationTitle'
      ],
      filters: 'statusID!=2'
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-sn")}',
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("condition")}',
      field: 'conditionTitle',
      sortable: {
        custom: 'condition.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("release")}',
      field: 'releaseTitle',
      sortable: {
        custom: 'release.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("tag-date")}',
      field: 'tagDate',
      template: 'date'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("rep-shop")}',
      field: 'tagInfoCompanyName',
      sortable: {
        custom: 'tagInfoCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("price")}',
      field: 'sellPrice',
      template: (data) => toPriceCurrency(data.sellPrice, data.currencyTitle)
    },
    ...(isPreview ? [
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("stock-location")}',
        field: 'locationTitle',
        sortable: {
          custom: 'stockLocation.title'
        }
      },
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("external-location-company")}',
        field: 'externalLocationCompanyName',
        sortable: {
          custom: 'externalLocationCompany.name'
        }
      }
    ] : [])
  ],
  sortable: {
    field: 'entryDate',
    order: 'desc'
  },
  rowControls: {
    left: {
      classes: 'controls-inline',
      controls: [
        ...(
          isPreview
            ? []
            : [
              {
                type: 'custom',
                // eslint-disable-next-line no-template-curly-in-string
                title: "${root.L10n('add-to-quote')}"
              }
            ]
        ),
        {
          type: 'custom',
          action: 'STOCK_CARD',
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('open-stock-card')}"
        },
        ...(isPreview ? [
          { type: 'custom',
            action: 'REPAIR_STATUS_CARD',
            // eslint-disable-next-line no-template-curly-in-string
            title: "${root.L10n('open-repair-status')}"
          }] : [])
      ]
    }
  },
  header: {
    isVisible: false
  }
})
